import { useEffect } from 'react';
import useStore from '~/store';

export const DEFAULT_DOCUMENT_TITLE = 'Aride - Associe-se agora';

/**
 * Deixa o título da aba do navegador dinâmico conforme o parceiro/clube.
 *
 * O nome do clube já chega na rota `flow` (GET /Plans/{plan}/flow) e é
 * persistido no store em `planOptions.club.club_name` (e também em `club_name`
 * quando vem do fluxo de contrato). Enquanto não houver clube, mantém o título
 * padrão da Aride.
 */
export function useDocumentTitle(): void {
  const clubName = useStore((store) => (store.planOptions?.club?.club_name || store.club_name || '') as string);

  useEffect(() => {
    const name = clubName?.trim();
    document.title = name ? `${name} | Aride` : DEFAULT_DOCUMENT_TITLE;
  }, [clubName]);
}

export default useDocumentTitle;
